/**
 * FormattedText Component
 * Renders text with markdown-like formatting (headers, bold, lists)
 */

import React from 'react';
import './FormattedText.css';

export const FormattedText = ({ text }) => {
  if (!text) return null;

  const formatLine = (line) => {
    // Split by ** for bold text
    const parts = line.split(/(\*\*.*?\*\*|\*.*?\*)/g);

    return parts.map((part, index) => {
      // Handle **bold** (double asterisks)
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      // Handle *bold* (single asterisks)
      if (part.startsWith('*') && part.endsWith('*')) {
        return <strong key={index}>{part.slice(1, -1)}</strong>;
      }
      return part;
    });
  };

  const lines = text.split('\n');

  return (
    <div className="formatted-text">
      {lines.map((line, index) => {
        const trimmedLine = line.trim();

        // Check for markdown headers (# ## ### ####)
        if (trimmedLine.startsWith('####')) {
          return (
            <h4 key={index} className="formatted-text-h4">
              {formatLine(trimmedLine.slice(4).trim())}
            </h4>
          );
        }
        if (trimmedLine.startsWith('###')) {
          return (
            <h3 key={index} className="formatted-text-h3">
              {formatLine(trimmedLine.slice(3).trim())}
            </h3>
          );
        }
        if (trimmedLine.startsWith('##')) {
          return (
            <h2 key={index} className="formatted-text-h2">
              {formatLine(trimmedLine.slice(2).trim())}
            </h2>
          );
        }
        if (trimmedLine.startsWith('#')) {
          return (
            <h1 key={index} className="formatted-text-h1">
              {formatLine(trimmedLine.slice(1).trim())}
            </h1>
          );
        }

        // Check if line starts with dash (list item)
        if (trimmedLine.startsWith('-')) {
          return (
            <div key={index} className="formatted-text-list-item">
              <span className="formatted-text-bullet">•</span>
              <span>{formatLine(trimmedLine.slice(1).trim())}</span>
            </div>
          );
        }

        // Regular line
        if (trimmedLine) {
          return (
            <div key={index} className="formatted-text-line">
              {formatLine(line)}
            </div>
          );
        }

        // Empty line for spacing
        return <div key={index} className="formatted-text-spacer" />;
      })}
    </div>
  );
};
